import { writable } from 'svelte/store';
import { get } from 'svelte/store';

const AUTH_TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refreshToken';
const USER_INFO_KEY = 'userInfo';
import { client } from 'root/api/index.js';

const initialState = {
  isLoggedIn: false,
  user: undefined,
};

let authToken;

export const getAuthToken = () => authToken;
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
export const setAuthToken = (token, userInfo) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(USER_INFO_KEY, userInfo || '{}');

  authStore.set({ isLoggedIn: true, user: userInfo ? JSON.parse(userInfo) : {} });
  authToken = token;
};
export const getUserInfo = () => {
  try {
    const authUser = get(authStore).user.info;
    return authUser || {};
  } catch (e) {
    return {};
  }
};
export const authStore = writable(initialState);

const safeJsonParse = (jsonString) => {
  try {
    return JSON.parse(jsonString);
  } catch {
    return null;
  }
};

export const loginWillExpire = () => {
  // get token and extract the payload
  const tokenExp = localStorage.getItem(AUTH_TOKEN_KEY)?.split?.('.')?.[1];
  if (!tokenExp) return false;
  // parse the payload and extract the expiration timestamp
  const timeStampExp = safeJsonParse(atob(tokenExp))?.exp;
  // convert the timestamp to date and subtract 3 min and compare with the now time.
  if (timeStampExp) return timeStampExp * 1000 - 3 * 60 * 1000 - Date.now();
  return false;
};

export const setUser = (user) => {
  authStore.set({ isLoggedIn: true, user: user.info });
};

// Refactored code to clear the user and tokens
export const clearUser = (url) => {
  // Removing old token from the localStorage as this is still a valid token
  localStorage.removeItem('authToken');
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(USER_INFO_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  authToken = undefined;
  window.location.href = url || '/ui/login';
};

export const resetUserData = () => {
  client
    .userInfo()
    .then((results) => {
      let user = results.data.info;
      let authUser = get(authStore).user;

      authStore.set({
        isLoggedIn: true,
        user: {
          ...authUser,
          info: user,
        },
      });

      let auths = get(authStore).user;
      localStorage.setItem(USER_INFO_KEY, JSON.stringify(auths || {}));
    })
    .catch((err) => {});
};

export const checkRole = (roleId) => {
  try {
    return roleId == getUserInfo().roleId;
  } catch (err) {
    return false;
  }
};
